module.exports = __webpack_public_path__ + "img/ps.3c893b30.svg";